/* @flow */

import * as React from "react";
import { FormattedMessage } from "react-intl";
import { notify as notificationsNotify } from "../uidispatcherapi/Notifications";
import { jsxWithIntl } from "../i18n/IntlRootMixin";

export type IntlNotification = {
    type: "server-error" | "user-error" | "warning" | "info" | "success";
    key: string;
    values?: {
        [x: string]: any;
    };
    id: string;
    extras?: React.ReactNode;
    timeout?: number;
};

export type NotificationHandle = {
    readonly dismiss: () => void;
};

export function notify(data: IntlNotification): NotificationHandle {
    if (!notificationsNotify) {
        return { dismiss: () => undefined };
    }

    const notification = {
        type: data.type,
        id: data.id,
        text: jsxWithIntl(
            <div>
                <FormattedMessage id={data.key} values={data.values} />
                {data.extras ? <React.Fragment> {data.extras}</React.Fragment> : null}
            </div>
        )
    };

    const notificationWithTimeout = data.timeout ? Object.assign({}, notification, { timeout: data.timeout }) : notification;

    return notificationsNotify(notificationWithTimeout);
}
